<div class="wrapper">
    
    <h1 role="heading" class="screen-reader-only" aria-label="My Direct Reports">My Direct Reports</h1>
    <span class="h4 mb-3" style="display:inline-block">My Direct Reports</span>

    <mat-expansion-panel class="mb-3" (opened)="infoPanelOpenState = true" (closed)="infoPanelOpenState = false">
        <mat-expansion-panel-header aria-label="Please do not share...">
            <mat-panel-title class="expansion-text">
                <ng-container *ngIf="!infoPanelOpenState">
                    <i class="fa fa-info-circle fa-fw mr-3 mt-1"></i>
                    Please do not share...
                </ng-container>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="expansion-text">
            <p>
                <i class="fa fa-info-circle fa-fw mr-1"></i>Please do not share or publish information from the exports without consent from the employee as the narratives may not be 
                written for public consumption. Reporting exports may be used for monitoring and informational purposes.
            </p>
            <p>
                This list includes the names of your direct reports, your supervising role, and the names and roles of other supervisors.  
                If you have questions or see any missing information, please contact Academic Human Resources 
                (Anna Lee at <a href="mailto:anlee@ucanr.edu"><i class="fa fa-envelope fa-fw mr-1"></i>anlee@ucanr.edu</a>). 
            </p>
        </div>
    </mat-expansion-panel>    

    <div *ngIf="loading">
        <p>Loading...</p>
    </div>

    <div *ngIf="error">
        <div class="alert alert-danger">
            <i class="fa fa-warning"></i> Unable to load direct reports
        </div>
    </div>

    <div *ngIf="!error && !loading && directReports.length === 0">
        <div class="alert alert-warning">
            <i class="fa fa-warning"></i> No direct reports found
        </div>
    </div>
    
    <div *ngIf="!error && !loading && directReports.length > 0">

        <mat-form-field *ngIf="myRoles?.size > 1" appearance="fill" class="w-100">
            <mat-label>Filter by 'My Role'</mat-label>
            <mat-select [formControl]="supervisorRoles" multiple>
                <mat-option *ngFor="let role of myRoles" [value]="role">{{role}}</mat-option>
            </mat-select>
        </mat-form-field>

        <div class="d-none d-md-block">
            <div class="row pb-4">
                <div class="col text-right text-muted">{{ getDirectReportCount() }}</div>
            </div>
            <div class="row px-4 py-2 font-weight-bold border-bottom">
                <div class="col-2">Academic</div>
                <div class="col-3">My Role</div>
                <div class="col-4">Other Supervisors</div>
                <div class="col-3">Reporting Export</div>
            </div>
            <div class="row px-4 py-3 hover-highlight" *ngFor="let report of filteredDirectReports">
                <div class="col-2">{{ report.directReportName }}</div>
                <div class="col-3">
                    <ng-container *ngIf="getSuperviorTitleAndParticipation(report) as supervisor">
                        {{ supervisor.title }} <small class="text-muted">({{ supervisor.reviewParticipation }})</small>
                    </ng-container>
                </div>
                <div class="col-4">
                    <ng-container *ngIf="getOtherSupervisors(report) as otherSupervisors;">
                        <div *ngIf="otherSupervisors.length === 0">--</div>
                        <div *ngFor="let supervisor of otherSupervisors">
                            {{ supervisor.name }}
                            <small class="text-muted">({{ supervisor.title }}; {{ supervisor.reviewParticipation }})</small>
                        </div>
                    </ng-container>
                </div>
                <div class="col-3 d-flex align-items-center">
                    <button class="btn btn-primary btn-block" (click)="openExportDataDialog(report.directReportID)">
                        <i class="fa fa-fw fa-cloud-download"></i> Export
                    </button>
                </div>
            </div>
        </div>

        <!-- Small screen card layout -->
        <div class="d-block d-md-none">
            <div class="row pb-4">
                <div class="col text-right text-muted">{{ getDirectReportCount() }}</div>
            </div>            
            <div class="card mb-3" *ngFor="let report of filteredDirectReports">
                <div class="card-body p-3">
                    <h5>{{ report.directReportName }}</h5>
                    <p class="mb-1">
                        <span class="font-weight-bold">My Role: </span>
                        <ng-container *ngIf="getSuperviorTitleAndParticipation(report) as supervisor">
                            {{ supervisor.title }} <small class="text-muted">({{ supervisor.reviewParticipation }})</small>
                        </ng-container>
                    </p>
                    <p class="mb-0">
                        <span class="font-weight-bold">Other Supervisors: </span>
                        <ng-container *ngIf="getOtherSupervisors(report) as otherSupervisors">
                            <span *ngIf="otherSupervisors.length === 0">--</span>
                            <span *ngFor="let supervisor of otherSupervisors">
                                <ul class="list-unstyled mb-0">
                                    <li>
                                        - {{ supervisor.name }}
                                        <small class="text-muted">
                                            ({{ supervisor.title }}; {{ supervisor.reviewParticipation }})
                                        </small>
                                    </li>
                                </ul>
                            </span>
                        </ng-container>
                    </p>
                    <button type="button" class="mt-3 btn btn-primary btn-block" (click)="openExportDataDialog(report.directReportID)">
                        <i class="fa fa-fw fa-cloud-download"></i> Export
                    </button>
                </div>
            </div>
        </div>

    </div>
</div>